module.exports = __webpack_public_path__ + "img/resilience1.f6d96fbc.png";